import React from 'react'
import { socials } from '../../constants/socialData'

const SocialsMedia = () => {
    return (
        <section className="bbg-slate-900/50 py-4 px-6 flex flex-col items-center justify-center">
            <p className="text-center text-base md:text-xl"> Seguinos en nuestras redes sociales </p>
            <div className="max-w-4xl w-full flex justify-center gap-4 lg:gap-10">

                {socials.map(({ name, icon: Icon, url, color }) => (
                    <a
                        key={name}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={name}
                        className="text-white  text-2xl p-4 rounded-full hover:scale-110 transition-transform"
                        style={{ color }}
                    >
                        <Icon />
                    </a>
                ))}
            </div>
        </section>
    )
}
export default SocialsMedia